import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import ThemeExport from "../ThemeExport.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Modal(_ref) {
  var {
    className = 'theme-bg-light',
    children,
    role = 'role',
    keyboard = true,
    isOpen = false,
    centered = false,
    size,
    onOpened,
    onClosed,
    toggle,
    'data-testid': dataTestId
  } = _ref;
  var element = useRef();
  var background = useRef(null);
  var [backgroundClicked, setBackgroundClicked] = useState(false);
  var handleKeyDown = useCallback(event => {
    switch (event.key) {
      case 'Escape':
        toggle === null || toggle === void 0 ? void 0 : toggle();
        break;
      default:
        break;
    }
  }, [toggle]);
  useEffect(function addKeydownEventListener() {
    if (isOpen && keyboard) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [handleKeyDown, isOpen, keyboard]);
  useEffect(function open() {
    if (isOpen && onOpened) {
      onOpened();
    }
  }, [onOpened, isOpen]);
  useEffect(function closed() {
    if (!isOpen && onClosed) {
      onClosed();
    }
  }, [onClosed, isOpen]);
  if (isOpen && !element.current) {
    element.current = document.createElement('div');
    element.current.setAttribute('style', 'padding-right: 15px; display: block');
    element.current.setAttribute('role', 'presentation');
    document.body.appendChild(element.current);
  }
  var onExited = () => {
    if (element.current) {
      document.body.removeChild(element.current);
      element.current = undefined;
    }
  };
  return element.current ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CSSTransition, {
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isOpen,
      classNames: {
        appearActive: 'show',
        appearDone: 'show'
      },
      timeout: ThemeExport.transitionMs,
      onExited: onExited,
      children: /*#__PURE__*/_jsx("div", {
        className: classNames('modal-backdrop fade'),
        style: {
          zIndex: 1050
        }
      })
    }), /*#__PURE__*/_jsx(CSSTransition, {
      appear: true,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isOpen,
      classNames: {
        appearDone: 'show'
      },
      timeout: ThemeExport.transitionMs,
      onExited: onExited,
      children: /*#__PURE__*/_jsx("div", {
        ref: background,
        className: "modal fade",
        onMouseDown: e => {
          if (e.target === background.current) {
            setBackgroundClicked(true);
          } else {
            setBackgroundClicked(false);
          }
        },
        onMouseUp: e => {
          if (backgroundClicked && e.target === background.current && toggle !== undefined) {
            toggle();
          }
        },
        role: "dialog",
        style: {
          display: 'block'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: classNames("modal-dialog ".concat(className), {
            'modal-lg': size === 'lg',
            'modal-sm': size === 'sm',
            'modal-xl': size === 'xl',
            'modal-dialog-centered': centered
          }),
          style: {
            zIndex: 1040
          },
          children: /*#__PURE__*/_jsx("div", {
            className: "modal-content",
            role: "presentation",
            "data-testid": dataTestId,
            children: children
          })
        })
      })
    })]
  }), element.current) : null;
}
export default Modal;
//# sourceMappingURL=Modal.js.map